import React, { useCallback, useEffect, useRef, useState } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const autoScrollRef = useRef(null);

  const testimonials = [
    {
      name: 'Addison Swan',
      review: 'Came and cleared the driveway with short notice. Salted and cleared the ice, also adding salt to ensure no more ice. Great price point!!!! Thank you so much!!',
      rating: 5,
    },
    {
      name: 'Niaz Razack',
      review: 'Highly recommend Chamak Steel for your railings! They were very prompt and responsive from the initial quote to installation date. They were able to have my railings in within 3 weeks. Very satisfied with the outcome.',
      rating: 5,
    },
    {
      name: 'Navdeep Sandhu',
      review: 'Prime Lawn & Snow Management provided on-time and excellent service last year, saving me from three major snowstorms and handling my lawn with great care. They took extra time to ensure my lawn looked perfect, going beyond expectations. Glad to be on board again this year—now I can relax knowing my lawn is in good hands. Highly recommend!',
      rating: 4,
    },
    {
      name: 'Vincent Wu',
      review: "I'm so impressed with prime snow removal service I hired this winter! They are always on time and do a great job clearing my driveway and walkways. The owner is incredibly easy to work with, making the whole process seamless and stress-free. Highly reliable and professional—I'm so glad I chose them!",
      rating: 5,
    },
    {
      name: 'Mary Jae Love',
      review: 'I was on vacation and my driveway had snow piled up from the recent heavy snowfall this past week. I called Prime Lawn and Snow Management and they were able to accommodate me and even with some reservations because there was A LOT of snow especially compact snow at the end of the driveway, they still were willing to take a chance with what they had and cleared my driveway before I headed back from vacation. Saved me a lot of time and hard labour. They were prompt, friendly and did a great job. Thank you.',
      rating: 4,
    },
    {
      name: 'Hollie Jamieson',
      review: "Prime to the rescue! We've had a rough time and our driveway got out of control after all the snow we've gotten recently. I didn't have the time (or energy) to get it done so I called Prime to ask for help and did they ever! They were able to help us out and worked us into their schedule of their other customers. Now I'm not off-roading to get into or out of our driveway!! I would definitely recommend them and I know I can count on them in the future.",
      rating: 5,
    },
    {
      name: 'paras miglani',
      review: 'We recently called Lawn Care because we had trouble with the mowing. Within a few days, they sent someone, and he did a fantastic job. The cost is affordable. Try it!',
      rating: 4,
    },
    {
      name: 'Laila Benrarib',
      review: 'Prime Lawn & Snow Management provides reliable and efficient service. They keep my lawn looking great and handle snow removal flawlessly. Highly recommend!',
      rating: 5,
    },
  ];

  const getItemsPerView = () => {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  };

  const [itemsPerView, setItemsPerView] = useState(getItemsPerView());

  useEffect(() => {
    const handleResize = () => setItemsPerView(getItemsPerView());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, testimonials.length - itemsPerView);

  const startAutoScroll = useCallback(() => {
    autoScrollRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 4000);
  }, [maxIndex]);

  const stopAutoScroll = useCallback(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }
  }, []);

  useEffect(() => {
    startAutoScroll();
    return () => stopAutoScroll();
  }, [startAutoScroll, stopAutoScroll]);

  const handlePrevClick = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const handleNextClick = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const renderStars = (rating) => '⭐'.repeat(rating);

  return (
    <section className="py-4 md:py-4">
      <h1 className="dest_heading">Our Testimonials</h1>

      <div className="relative mx-auto my-4 max-w-7xl px-4 sm:px-6">
        <button
          type="button"
          onClick={handlePrevClick}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-3 hover:bg-gradient-to-r hover:from-[#3f9422] hover:to-[#8ecb27] hover:text-white transition-all duration-300"
        >
          &#8592;
        </button>
        <button
          type="button"
          onClick={handleNextClick}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-3 hover:bg-gradient-to-r hover:from-[#3f9422] hover:to-[#8ecb27] hover:text-white transition-all duration-300"
        >
          &#8594;
        </button>

        <div
          className="overflow-hidden px-8"
          onMouseOver={stopAutoScroll}
          onMouseOut={startAutoScroll}
        >
          <div
            className="flex transition-transform duration-300 ease-in-out gap-6"
            style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`testimonial-card flex flex-col gap-4 p-6 font-semibold flex-shrink-0 ${
                  itemsPerView === 1
                    ? 'w-[calc(100%-16px)]'
                    : itemsPerView === 2
                      ? 'w-[calc(50%-12px)]'
                      : 'w-[calc(33.333%-16px)]'
                }`}
              >
                <span>{testimonial.name}</span>
                <span className="title-font font-medium">{testimonial.review}</span>
                <div className="text-sm flex gap-1">{renderStars(testimonial.rating)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;